import {
    apiRequest,
    HDdetail,
    HDCreateManual,
    PegawaiEmployeeList,
    HukdisList,
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class CreateManualRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HDdetail, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", HDCreateManual, {
            body: query
        }, true)
    }

    fetchEmployeeList = async (query, cancelToken) => {
        return await apiRequest("get", PegawaiEmployeeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchHukdisList = async (query, cancelToken) => {
        return await apiRequest("get", HukdisList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default CreateManualRepository